import MicIcon from '@mui/icons-material/Mic';
import StadiumIcon from '@mui/icons-material/Stadium';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';

// This function can be used outside of React components by importing i18n directly
export const getCategoryLabel = (key: string): string => {
  if (!key) return '';
  return (i18n.t as any)(`categories.${key}`, key);
};

// For React components, use this hook-based version which will update when language changes
export const useCategoryLabel = () => {
  const { t } = useTranslation();
  return (key: string) => {
    if (!key) return '';
    return (t as any)(`categories.${key}`, key);
  };
};

export const categoryIcons: Record<string, JSX.Element> = {
  REHEARSAL: <StadiumIcon fontSize="small" />,
  RECORDING: <MicIcon fontSize="small" />,
  PRACTICE: <MusicNoteIcon fontSize="small" />,
};

